/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `in_progress` - 처리 중
 * `completed` - 완료
 * `failed` - 실패
 * `paused` - 일시정지
 */
export type Status006Enum = (typeof Status006Enum)[keyof typeof Status006Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Status006Enum = {
  pending: "pending",
  in_progress: "in_progress",
  completed: "completed",
  failed: "failed",
  paused: "paused",
} as const;
